import { Car } from 'lucide-react';
import React from 'react';

import { SingleModuleAuditPage } from '@/features/imports/SingleModuleAuditPage';

export const AuditTransferImportsPage = (): React.JSX.Element => (
  <SingleModuleAuditPage
    config={{
      moduleKey: 'transfer',
      titlePlural: 'transfers',
      routePrefix: 'transfers',
      listPath: '/transfers',
      ListIcon: Car,
    }}
  />
);
